import React, { useState, useEffect } from 'react'
import { Form, Input, Select, Checkbox } from 'antd'
import styleStudio from './styles.module.sass'
import styleFlow from './styles.module.sass'
import { Button, Modal, Toast } from "./helpers/commonUi";
// import CodeEditor from "./helpers/CodeEditor2";
import { uuid } from "./helpers/commonFunction";
import { getAxiosInstance } from './helpers/axois'
import DeleteIcon from './assets/svg/delete.svg';
import './main.sass'
import './mainFlow.sass'
import { useToast, addToast } from './context/ToastContext'

interface IProps {
    createCollection?: any,
    prevCollection?: any,
    editCollection?: any,
    editData?: any,
    appId?: string,
    versionId?: string,
    branchId?: string,
    from: string,
    token?: string,
    appType: 'solo' | 'assisted',
}

const DataModalContent = (props: IProps) => {

    const style = (props.from === 'studio') ? styleStudio : styleFlow
    const { Option } = Select
    const [fieldList, setFieldList] = useState<any[]>([])
    const { editData, prevCollection } = props
    const [collectionName, setCollectionName] = useState<string>((editData && editData.coll_name) || '')
    const [isPublic, setIsPublic] = useState<boolean>((editData && editData.is_public) || false)
    const [schemaModalVisible, setSchemaModalVisible] = useState<boolean>(false)
    const [jsonSchema, setJsonSchema] = useState<any>((editData && JSON.parse(JSON.stringify(editData.coll_schema))) || {
        $id: `${props.appId}/${props.versionId}/${uuid()}`,
        $schema: "http://json-schema.org/draft-07/schema#",
        title: "Data collection",
        description: "A8Data Collection",
        type: 'object',
        properties: {},
        required: [],
        additionalProperties: false
    })

    const { dispatch: toastDispatch } = useToast();
    const previousVersionSchema = prevCollection && prevCollection.coll_schema.properties
    const appId = props.appId
    const versionId = props.versionId
    const branchId = props.branchId
    const createCollection = props.createCollection
    const editCollection = props.editCollection
    const Http = getAxiosInstance(props.from, props.token)
    const onSaveSchema = (value: any) => {
        if (value && value.source !== 'Error') {
            const jsonSchemaCopy = JSON.parse(JSON.stringify(jsonSchema))
            let error: boolean = false
            if (previousVersionSchema) {
                const incomingProperties = JSON.parse(value.source)
                const incomingPropertiesKeys = Object.keys(incomingProperties)
                const initialEditDataKeys = Object.keys(previousVersionSchema)
                initialEditDataKeys.forEach((key: string) => {
                    // check if saved schema keys has all the original keys
                    if (incomingPropertiesKeys.includes(key)) {
                        if (JSON.stringify(incomingProperties[key]) !== JSON.stringify(previousVersionSchema[key])) {
                            error = true
                        }
                    } else {
                        error = true
                    }
                })
            }
            if (!error) {
                jsonSchemaCopy.properties = JSON.parse(value.source)
                setJsonSchema(jsonSchemaCopy)
            } else {
                toastDispatch(addToast("Cannot modify existing fields", "error"))
                //return true says code-editor modal to stay open
                return true
            }
        } else {
            toastDispatch(addToast("Errors found in schema", "error"))
            //return true says code-editor modal to stay open
            return true
        }
    }
    const onEditSchema = () => {
        const jsonSchemaCopy = JSON.parse(JSON.stringify(jsonSchema))
        const jsonProperties = jsonSchemaCopy.properties
        fieldList.forEach((field: any) => {
            if (field.fieldName && field.fieldType) {
                // jsonProperties[field.fieldName] = {
                //     type : field.fieldType
                // }
                jsonProperties[field.fieldName] = field.fieldValue ?
                    field.fieldValue
                    :
                    {
                        type: field.fieldType
                    }
            }
        })
        setJsonSchema(jsonSchemaCopy)
        setSchemaModalVisible(true)
    }

    useEffect(() => {
        const generatedFieldList: any[] = []
        const { properties }: { properties: any } = jsonSchema
        Object.entries(properties).forEach((field: any) => {
            generatedFieldList.push({
                id: uuid(),
                fieldName: field[0],
                fieldType: field[1].type || 'string',
                fieldValue: field[1]
            })
        })
        setFieldList(generatedFieldList)
    }, [jsonSchema])

    useEffect(() => {
        let parentCallback: any;
        jsonSchema.properties = {}
        fieldList.forEach((field: any) => {
            if (field.fieldName && field.fieldType) {
                jsonSchema.properties[field.fieldName] = field.fieldValue ?
                    field.fieldValue
                    :
                    {
                        type: field.fieldType
                    }
            }
        })
        if (collectionName && (Object.keys(jsonSchema.properties).length > 0)) {
            editData ?
                parentCallback = (callback: any) => {
                    Http.put(`/app/${appId}/collections/${collectionName}?versionId=${versionId}&branchId=${branchId}`, {
                        schema: jsonSchema,
                        isPublic
                    }).subscribe(() => {
                        // toastDispatch(addToast("Schema update successful", "success"))
                        callback()
                    }, (_err: any) => {
                        // toastDispatch(addToast((err && err.message) ? err.message : 'Schema update failed', "error"))
                    })
                    // Close modal after execution
                    return false
                }
                :
                parentCallback = (callback: any) => {
                    Http.post(`/app/${appId}/collections`, {
                        name: collectionName,
                        versionId: versionId,
                        schema: jsonSchema,
                        branchId: branchId,
                        isPublic
                    }).subscribe(() => {
                        // toastDispatch(addToast("Collection created", "success"))
                        callback()
                    }, (_err: any) => {
                        // toastDispatch(addToast((err && err.message) ? err.message : 'Collection creation failed', "error"))
                    })
                    // Close modal after execution
                    return false
                }
        } else {
            parentCallback = () => {
                !collectionName && toastDispatch(addToast('Collection name cannot be empty', "error"))
                !(Object.keys(jsonSchema.properties).length > 0) && toastDispatch(addToast('Atleast one property required', "error"))
                // Keep modal open after execution
                return true
            }
        }

        editData
            ?
            editCollection && editCollection(parentCallback)
            :
            createCollection && createCollection(parentCallback)

    }, [appId, versionId, jsonSchema, collectionName, createCollection, editCollection, fieldList, editData, isPublic])

    return (
        <div className={style.modalContentContainer + ` override-content${props.from === 'studio' ? '' : '-flow'}`}>
            <div className={style.idRow}>
                <Form.Item className={`override-first-tree-root${props.from === 'studio' ? '' : '-flow'}`} label={<span className={style.labelName}>_id</span>}>
                    <Input
                        disabled
                        placeholder={editData ? editData.coll_id : '*Auto generated ID'}
                    />
                </Form.Item>
                <Form.Item label={<span className={style.labelName}>Collection Name</span>}>
                    <Input
                        placeholder='Enter collection name'
                        value={collectionName}
                        disabled={editData ? true : false}
                        onChange={(e: any) => setCollectionName(e.target.value)}
                    />
                </Form.Item>
            </div>
            {
                fieldList && fieldList.map((field: any, index: number, list: any) => {
                    const keys = previousVersionSchema && Object.keys(previousVersionSchema)
                    const isDisabled = previousVersionSchema && keys.includes(field.fieldName) && (keys.indexOf(field.fieldName) === index)
                    return (
                        <div key={field.id} className={index === 0 ? style.fieldRowFirst : style.fieldRow}>
                            <Form.Item label={index === 0 ? 'Field' : undefined}>
                                <Input
                                    disabled={isDisabled}
                                    placeholder='Enter field name'
                                    value={field.fieldName}
                                    onChange={(e: any) => {
                                        const fieldCopy = { ...field }
                                        fieldCopy.fieldName = e.target.value
                                        const fieldListCopy = [...fieldList]
                                        fieldListCopy[index] = fieldCopy
                                        setFieldList(fieldListCopy)
                                    }}
                                    onBlur={(e: any) => {
                                        // Rename fieldname if it already exists
                                        const val = e.target.value
                                        const existingFields = list.filter((item: any) => (item.fieldName === e.target.value && item.id !== field.id))
                                        const existingDupFields = list.filter((item: any) => (item.fieldName.includes(`${e.target.value}_`) && item.id !== field.id)).length
                                        if (existingFields.length > 0) {
                                            const duplicateName = existingDupFields ? `${val}_${existingDupFields + 1}` : `${val}_1`
                                            const fieldCopy = { ...field }
                                            fieldCopy.fieldName = duplicateName
                                            const fieldListCopy = [...fieldList]
                                            fieldListCopy[index] = fieldCopy
                                            setFieldList(fieldListCopy)
                                        }
                                    }}
                                />
                            </Form.Item>
                            <div className={style.selectContainer}>
                                <Form.Item label={index === 0 ? 'Type' : undefined}>
                                    <Select
                                        disabled={isDisabled}
                                        style={{ width: '100%' }}
                                        onChange={(value: any) => {
                                            const fieldCopy = { ...field }
                                            fieldCopy.fieldType = value
                                            if (value === 'object') {
                                                fieldCopy.fieldValue = {
                                                    type: value,
                                                    properties: {}
                                                }
                                            } else if (value === 'array') {
                                                fieldCopy.fieldValue = {
                                                    type: value,
                                                    items: {}
                                                }
                                            } else {
                                                fieldCopy.fieldValue = {
                                                    type: value
                                                }
                                            }
                                            const fieldListCopy = [...fieldList]
                                            fieldListCopy[index] = fieldCopy
                                            setFieldList(fieldListCopy)
                                        }}
                                        defaultValue={field.fieldType}
                                    >
                                        <Option title='string' value='string' key='string'>string</Option>
                                        <Option title='number' value='number' key='number'>number</Option>
                                        <Option title='integer' value='integer' key='integer'>integer</Option>
                                        <Option title='object' value='object' key='object'>object</Option>
                                        <Option title='boolean' value='boolean' key='boolean'>boolean</Option>
                                        <Option title='array' value='array' key='array'>array</Option>
                                    </Select>
                                </Form.Item>
                            </div>
                            <div className={style.iconBox} style={{ marginTop: (index === 0) ? '40px' : '14px', cursor: isDisabled ? 'not-allowed' : 'pointer' }} onClick={(e) => {
                                e.stopPropagation()
                                if (!isDisabled) {
                                    const newList = fieldList.filter((record: any) => record.id !== field.id)
                                    setFieldList(newList)
                                }
                            }}>
                                <DeleteIcon height='14px' width='14px' style={{ color: isDisabled ? '#aaa' : '#FD2A0F' }} />
                            </div>
                        </div>
                    )
                })
            }
            {
                <div className={style.buttonsContainer}>
                    <div className={style.addFieldButton}>
                        <Button size='extra-small' color='primary-outlined'
                            from={props.from}
                            onClick={() => {
                                setFieldList([...fieldList, {
                                    id: uuid(),
                                    fieldName: '',
                                    fieldType: ''
                                }])
                            }}
                        >
                            ADD FIELD
                        </Button>
                    </div>
                    {/* <div className={editSchemaButton}>
                        <Button size='extra-small' color='primary-outlined'
                            onClick={onEditSchema}
                        >
                            EDIT SCHEMA
                        </Button>
                    </div> */}
                </div>
            }
            {
                props.appType === 'solo'
                &&
                (
                    <div style={{ marginLeft: '20px', marginTop: '40px'}}>
                        <Checkbox
                            data-test-id="form_checkbox"
                            checked={isPublic}
                            onChange={(e) => {
                                setIsPublic(e.target.checked)
                            }}
                        ></Checkbox>
                        <span style={{marginLeft: '8px'}}>IsPublic</span>
                    </div>
                )
            }
            
            <div style={props.appType === 'solo' ? {marginTop: '10px'} : { marginLeft: '20px', marginTop: '40px'}} className={style.editSchemaButton}>
                <Button size='extra-small' color='primary-outlined'
                    from={props.from}
                    onClick={onEditSchema}
                >
                    EDIT SCHEMA
                </Button>
            </div>
            <Modal
                from={props.from}
                title='EDIT SCHEMA'
                unmountOnCancel={true}
                footer={{
                    enable: true,
                    okText: 'SAVE',
                    cancelText: 'CANCEL',
                    onOk: () => setSchemaModalVisible(false)
                }}
                visible={schemaModalVisible}
                onCancel={() => setSchemaModalVisible(false)}
                width='800px'
                codeEditorProps={{
                    height: '450px',
                    value: JSON.stringify(jsonSchema.properties, undefined, 2),
                    onSave: onSaveSchema,
                    lang: 'json',
                    editRangePhrase: {
                        start: '{',
                        end: '}'
                    },
                    saveMessage: {
                        enable: true,
                        message: 'Schema'
                    }
                }}
            />
            <Toast closeIn={3500} from={props.from} />
        </div>
    )
}

export default DataModalContent